import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageContainer from '../components/shared/page/PageContainer';
import PageNavigateTitle from '../components/shared/page/PageNavigateTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import VehicleClient from '../components/vehicle/VehicleClient';
import VehicleInfo from '../components/vehicle/VehicleInfo';
import VehiclesHeader from '../components/vehicle/VehiclesHeader';
import VisitsHeader from '../components/visits/VisitsHeader';
import VisitsList from '../components/visits/VisitsList';
import VisitsPagination from '../components/visits/VisitsPagination';
import useFetchVehicle from '../hooks/vehicle/useFetchVehicle';

const Vehicle = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));
  const { vin } = useParams();
  const { vehicle, loading, refresh } = useFetchVehicle(vin);

  return (
    <Suspense fallback={<CommonLoader />}>
      {loading ? (
        <CommonLoader />
      ) : (
        <section>
          <PageTitleContainer>
            <PageNavigateTitle
              title={`${vehicle.brand.name} ${vehicle.model.name} ${vehicle.year ? `(${vehicle.year})` : ''}`.trim()}
              link={'/vehicles'}
            />
          </PageTitleContainer>
          <PageContainer>
            <Container>
              <VehiclesHeader readOnly={readOnly} refresh={refresh} />
              <VehicleInfo />
              <VehicleClient />
            </Container>
            <Container>
              <VisitsHeader readOnly={readOnly} />
              <VisitsList />
              <VisitsPagination />
            </Container>
          </PageContainer>
        </section>
      )}
    </Suspense>
  );
};

export default Vehicle;
